import { configServices } from 'src/services';
import { Container, FloatingLabel, Form } from 'react-bootstrap';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import { hideLoadingModalReducer, setAlertResponse, showLoadingModalReducer } from 'src/store';
import { useDispatch } from 'react-redux';
import { useGetConfig, useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    setShowSetCongregationArea: Dispatch<SetStateAction<boolean>>;
};

export const ConfigSetCongregationArea: FC<propsType> = ({ setShowSetCongregationArea }) => {
    const config = useGetConfig();
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    //
    const [congregationArea, setCongregationArea] = useState(config.congregationArea ?? '');

    const setCongregationAreaHandler = async () => {
        if (congregationArea.length < 3 || congregationArea.length > 25) {
            return;
        }
        dispatch(showLoadingModalReducer());
        const response = await configServices.SetCongregationArea(congregationArea);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
            return;
        }
        window.location.reload();
    }

    return (
        <Container className={'maxw-400'}>
            <FloatingLabel
                className={'mb-3 text-dark'}
                label={"Localidad de la Congregación"}
            >
                <Form.Control
                    type={'text'}
                    className={'form-control'}
                    placeholder={''}
                    value={congregationArea ? congregationArea : ''}
                    onChange={e => setCongregationArea( e.target.value)}
                    onKeyDown={e => e.key === 'Enter' ? setCongregationAreaHandler() : null }
                    autoFocus
                />
            </FloatingLabel>

            <button
                className={`btn btn-general-blue d-block w-100 mt-3`}
                style={{ fontWeight: 'bolder', height: '50px' }}
                onClick={setCongregationAreaHandler}
                disabled={congregationArea.length < 3 || congregationArea.length > 25}
            >
                Aceptar
            </button>

            <button
                className={`btn btn-general-red d-block w-100 mt-3`}
                style={{ fontWeight: 'bolder', height: '50px' }}
                onClick={() => setShowSetCongregationArea(false)}
            >
                Cancelar
            </button>
            <p className={`${isDarkMode ? 'text-white' : ''} text-center mt-3`}>
                Este dato es importante para el correcto funcionamiento de los servicios de geolocalización
            </p>
        </Container>
    );
}
